export const CONTENT_TYPES = {
  CASE_STUDIES: 'Case Studies',
  PODCASTS: 'Podcasts',
  VIDEOS: 'Videos',
  PSIRF: 'PSIRF',
  STANDBY_CPD: 'Standby CPD',
  PMAS: 'PMAs',
  PGDS: 'PGDs',
  QUIZZES: 'Quizzes',
  BOOKS: 'Books',
};
